module.exports = __webpack_public_path__ + "img/pointer-2.ff205cef.png";